import React, {ReactNode} from "react";

interface IControlBarMenuItemGroupProps {
  label?: string;
  children?: ReactNode;
}

export default function ControlBarMenuItemGroup({label, children}: IControlBarMenuItemGroupProps) {
  const labelEl = label ? <div className="label">{label}</div> : null;
  return (
    <div className="control-bar-menu-item-group">
      {labelEl}
      <div className="items">
        {children}
      </div>
    </div>
  );
}
